import Chip from "@mui/material/Chip";
import { ExpressDocumentStatus } from "../../types/express-document.type";
import { DOCUMENT_STATUS_COLOR, DOCUMENT_STATUS_LABEL } from "./constants";

export default function StatusChip({ status }: Readonly<{ status: ExpressDocumentStatus }>) {
  return (
    <Chip size="small" label={DOCUMENT_STATUS_LABEL[status]} color={DOCUMENT_STATUS_COLOR[status]} />
  );
}
